import React from 'react'
import { compose } from 'redux'
import cx from 'classnames'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

import opacity from '../../../../constants/opacity'

class Card extends React.Component {
  constructor (props) {
    super(props)
    this.state = {

    }
  }

  render () {
    const { classes, children, className, ...rest } = this.props

    return (
      <div className={cx(classes.card, className)} {...rest} >
        {children}
      </div>
    )
  }
}

const styles = {
  card: {
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#000000' + opacity[15],
    color: '#ffffff',
    padding: 8,
    borderRadius: 4,
    '& p': {
      margin: 0, // remove default margin of <p>
      letterSpacing: '0.025em',
    },
  },
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = {

}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(Card)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Card/index.jsx